module.exports = __webpack_public_path__ + "img/700_1.288831aa.png";